import { render } from "./HelpRulebooks.vue?vue&type=template&id=6e11d4a4&ts=true"
import script from "./HelpRulebooks.vue?vue&type=script&lang=ts"
export * from "./HelpRulebooks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__